export const TIMELINE_LIST_LIMIT = 9;

export const TYPE_TEXT = "text";
export const TYPE_IMAGE = "img";

export const FEEDBACK_RECEIVED = "messageReceived";
export const FEEDBACK_YES = "answeredYes";
export const FEEDBACK_FUNNY = "funny";
export const FEEDBACK_HAPPY = "happy";
export const FEEDBACK_LOVE = "love";
export const FEEDBACK_LUCKY = "lucky";
export const FEEDBACK_POSITIVE = "positive";
